
export const MaterialStatusConstant = {
    materialStatus: 'api/MaterialStatus',  
    materialStatusRoute: 'materialStatus',
    manageMaterialStatusRoute: 'manageMaterialStatus',
    bulkInsertMessage:'Material status are successfully importd',
    searchFieldName: 'name',
    code: 'code',
};